import axios from "axios";

export default class GPTService {
  static async ask(prompt: string) {
    return await axios.get(`https://api.socora.com/gpt?q=${prompt}`, {withCredentials: true})
  }
}